import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { useHistory } from 'react-router-dom';
import { Danger } from 'iconsax-react';

const ErrorModal = ({ ...props }) => {
  let history = useHistory();

  const [displayModal, setDisplayModal] = useState(false);

  const handleModal = (event) => setDisplayModal(!displayModal);

  const onClickAccept = (event) => {
    event.preventDefault();
    handleModal();
  };

  useEffect(() => {
    if (props.errorMessage.length !== 0) {
      setDisplayModal(true);
    } else {
      setDisplayModal(false);
    }
  }, [props.errorMessage]);

  return (
    <Modal
      isOpen={displayModal}
      className='bg-white fixed focus:outline-0 rounded-xl
      top-1/3 h-1/3 right-8 left-8 mx-10
      md:right-1/4 md:left-1/4 
      lg:right-1/3 lg:left-1/3'
      style={{
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.74)',
        },
      }}
    >
      <div className='flex flex-col items-center w-full h-full relative py-5'>
        <div className='flex flex-col items-center justify-center text-center text-mainText w-full'>
          <div className='bg-bgError p-6 rounded-xl w-fit'>
            <Danger color='#DF2040' size="20px" />
          </div>
          <h1 className='text-xl font-black mt-5 mb-3'>{props.title}</h1>
          <label className='text-md'>{props.errorMessage}</label>
        </div>
        <button
          onClick={(event) => onClickAccept(event)}
          className='small-button bg-primary-100 text-white text-md text-center absolute bottom-0 mb-5'
        >
          {locales('close')}
        </button>
      </div>
    </Modal>
  );
};

export default ErrorModal;
